import clinicalLogo from "@/assets/division-logos/clinical.svg";
import labServicesLogo from "@/assets/division-logos/lab-services.svg";
import qaLogo from "@/assets/division-logos/quality-assurance.svg";
import qvLogo from "@/assets/division-logos/qualification-validation.svg";
import raLogo from "@/assets/division-logos/regulatory-affairs.svg";
import swLogo from "@/assets/division-logos/software-solutions-services.svg";
import toxLogo from "@/assets/division-logos/regulatory-toxicology-mark.svg";
import pvLogo from "@/assets/division-logos/pharmacovigilance.svg";

import clinicalLogoDark from "@/assets/division-logos-dark/clinical.svg";
import labServicesLogoDark from "@/assets/division-logos-dark/lab-services.svg";
import qaLogoDark from "@/assets/division-logos-dark/quality-assurance.svg";
import qvLogoDark from "@/assets/division-logos-dark/qualification-validation.svg";
import raLogoDark from "@/assets/division-logos-dark/regulatory-affairs.svg";
import swLogoDark from "@/assets/division-logos-dark/software-solutions-services.svg";
import toxLogoDark from "@/assets/division-logos-dark/regulatory-toxicology-mark.svg";
import pvLogoDark from "@/assets/division-logos-dark/pharmacovigilance.svg";

export const DIVISION_LOGOS: Record<string, { src: string; srcDark: string; alt: string; serviceLabel?: string }> = {
  "clinical-solutions": { src: clinicalLogo, srcDark: clinicalLogoDark, alt: "QbD Clinical" },
  "lab-services": { src: labServicesLogo, srcDark: labServicesLogoDark, alt: "QbD Lab Services" },
  "quality-assurance": { src: qaLogo, srcDark: qaLogoDark, alt: "QbD Quality Assurance" },
  "qualification-validation": { src: qvLogo, srcDark: qvLogoDark, alt: "QbD Qualification & Validation" },
  "regulatory-affairs": { src: raLogo, srcDark: raLogoDark, alt: "QbD Regulatory Affairs" },
  "software-solutions-services": { src: swLogo, srcDark: swLogoDark, alt: "QbD Software Solutions & Services" },
  "toxicology": { src: toxLogo, srcDark: toxLogoDark, alt: "QbD Group", serviceLabel: "Regulatory Toxicology" },
  "pharmacovigilance": { src: pvLogo, srcDark: pvLogoDark, alt: "QbD Pharmacovigilance" },
};
